(function () {
  if (window.__lucideAuto) return;
  window.__lucideAuto = true;

  var SRC = 'https://unpkg.com/lucide@latest';
  var pending = false;

  function render() {
    pending = false;
    if (window.lucide && document.querySelector('i[data-lucide]')) {
      window.lucide.createIcons({ attrs: { 'aria-hidden': 'true' } });
    }
  }

  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(render);
  }

  function load() {
    if (window.lucide) return render();
    var existing = document.querySelector('script[src="' + SRC + '"]');
    if (existing) {
      existing.addEventListener('load', render);
      return;
    }
    var script = document.createElement('script');
    script.src = SRC;
    script.async = true;
    script.onload = render;
    document.head.appendChild(script);
  }

  function start() {
    if (document.querySelector('i[data-lucide]')) load();
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('i[data-lucide]') || node.querySelector('i[data-lucide]')) {
            window.lucide ? schedule() : load();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
